import { FC } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Scrollbar, Navigation, Pagination, Autoplay } from 'swiper';
// import EFPicture from '@elem/compCommon/EFPicture';
import EfImg from '@elem/ui/ef-img';
import EfSpec from '@elem/ui/ef-spec';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

const TheComp: FC = () => {
    const { useLang, useEffect, useState, useRouter, gtm } = useGlobal();
    const { locale } = useRouter();
    const IS_EU_SITES = ['eu', 'de', 'fr', 'it', 'es', 'ph'].includes(locale);
    const IS_CN_SITE = locale === 'cn';
    const { t } = useLang(IS_EU_SITES ? 'dp3.landing.TextListA' : 'dp3.teaser.TextListA');
    const [gap, setGap] = useState(24);

    const lists = [
        {
            title: t('title1'),
            desc: t('desc1'),
            pc: IS_EU_SITES
                ? 'https://websiteoss.ecoflow.com/upload/image/1724291965365/%E5%BE%AE%E9%80%86%2Bdp3-%E5%A4%A7%E7%BE%8E%E5%9B%BE-%E6%AC%A7%E8%A7%84.jpg'
                : locale === 'au'
                ? 'https://websiteoss.ecoflow.com/upload/image/1726666561604/a1.jpg'
                : 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717212248224/a1.jpg',
            pad: IS_EU_SITES
                ? 'https://websiteoss.ecoflow.com/upload/image/1724291965365/%E5%BE%AE%E9%80%86%2Bdp3-%E5%A4%A7%E7%BE%8E%E5%9B%BE-%E6%AC%A7%E8%A7%84.jpg'
                : locale === 'au'
                ? 'https://websiteoss.ecoflow.com/upload/image/1726666561604/a1.jpg'
                : 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717212383648/a2.jpg',
            h5: IS_EU_SITES
                ? 'https://websiteoss.ecoflow.com/upload/image/1724291965183/123.jpg'
                : locale === 'au'
                ? 'https://websiteoss.ecoflow.com/upload/image/1726666806874/a1.jpg'
                : 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717502849836/c3.jpg',
        },
        {
            title: t('title2'),
            desc: t('desc2'),
            pc:
                locale === 'au'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1726666561952/a2.jpg'
                    : 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717212535339/b1.jpg',
            pad:
                locale === 'au'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1726666561952/a2.jpg'
                    : 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717212550653/b2.jpg',
            h5:
                locale === 'au'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1726666807061/a2.jpg'
                    : 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717502915957/c2.jpg',
        },
        {
            title: t('title3'),
            desc: t('desc3'),
            tip: ['ca', 'us'].includes(locale) ? t('tip3') : '',
            pc:
                locale === 'jp'
                    ? 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717749827590/shp2%2Bdp3%20(1).jpg'
                    : locale === 'au'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1726666561773/a3.jpg'
                    : 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717212644468/c1.jpg',
            pad:
                locale === 'jp'
                    ? 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717749827590/shp2%2Bdp3%20(1).jpg'
                    : locale === 'au'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1726666561773/a3.jpg'
                    : 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717212663078/c2.jpg',
            h5:
                locale === 'jp'
                    ? 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717749927382/M-shp2%2Bdp3%20(1).jpg'
                    : locale === 'au'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1726666807242/a3.jpg'
                    : 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717212686554/c3.jpg',
        },
        {
            title: t('title4'),
            desc: t('desc4'),
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717212754827/d1.jpg',
            pad: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717212764822/d2.jpg',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717212773513/d3.jpg',
        },
    ];

    if (locale === 'au') {
        lists.pop();
    }

    const cards = IS_EU_SITES ? [1] : new Array(lists.length).fill(1);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const winW = window?.innerWidth;
            setGap(winW > 1440 ? 24 : winW > 1024 ? 16 : 10);
        }
    }, []);

    return (
        <div id="dp3-teaser-D" className={`${css.thecomp} dp3-teaser-D dp3-full`}>
            <ul className="lists">
                {lists?.map((list: any, k: number) => (
                    <li className="list" key={k}>
                        <p className="list-title">{list.title}</p>
                        <p className="list-desc">{list.desc}</p>
                        {list?.tip && <p className="list-tip">{list.tip}</p>}
                    </li>
                ))}
            </ul>
            {!['jp', 'cn'].includes(locale) && (
                <Swiper
                    className={`swiper-box${cards?.length === 1 ? ' single' : ''}`}
                    modules={[Scrollbar, Navigation, Pagination, Autoplay]}
                    navigation={cards?.length > 1}
                    pagination={cards?.length > 1}
                    loop={cards?.length > 1}
                    spaceBetween={gap}
                    centeredSlides={true}
                    slidesPerView={'auto'}
                    initialSlide={0}
                    // autoplay={{
                    //     delay: 3000,
                    //     disableOnInteraction: false,
                    //     pauseOnMouseEnter: true,
                    // }}
                >
                    {cards?.map((card: any, k: number) => {
                        const itemA = lists[k] || {};
                        return (
                            <SwiperSlide className={`swiper-item`} key={k}>
                                <div className="card-img">
                                    {/* <EFPicture src={itemA.pc} srcPad={itemA.pad} srcMobile={itemA.h5} alt={itemA?.text} /> */}
                                    <EfImg pc={itemA.pc} pad={itemA?.pad || ''} h5={itemA?.h5} />
                                </div>
                            </SwiperSlide>
                        );
                    })}
                    <p className="card-text">{t('card_text')}</p>
                </Swiper>
            )}
            {locale === 'ph' && <EfSpec className="spec-x" />}
            {IS_EU_SITES || (IS_CN_SITE && <EfSpec className="spec-x" />)}
        </div>
    );
};

export default TheComp;
